import axios from 'axios';

const token = localStorage.getItem('tokenImages');

const defaultHeaders = {
  Authorization: `Bearer ${token}`,
  'Content-Type': 'image/jpg'
};

export const apiGoogleStorage = axios.create({
  baseURL: process.env.REACT_APP_API_GOOGLE_STORAGE_URL,
  headers: { ...defaultHeaders }
});
